export default __webpack_public_path__ + "locales/ko-KR/Common.json?hash=44af0ba8d0d0248a601dac75e7ef3a42";